import { render, staticRenderFns } from "./NewCarRegistryForm.vue?vue&type=template&id=e4424a92&scoped=true&"
import script from "./NewCarRegistryForm.vue?vue&type=script&lang=js&"
export * from "./NewCarRegistryForm.vue?vue&type=script&lang=js&"
import style0 from "./NewCarRegistryForm.vue?vue&type=style&index=0&id=e4424a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4424a92",
  null
  
)

export default component.exports